import React, {Fragment} from 'react';
import createEditor, {referenceActionData} from '../form/ComponentEditor';
import Box from '../layout/Box';
import InvoicingForm from './forms/InvoicingForm';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import InvoicingList from "./lists/InvoicingList";
import {postData} from "../../utils/request";
import Modal from "../layout/Modal";
import Button from "../form/Button";
import connect from "react-redux/es/connect/connect";
import {showModal} from "../../actions";
import {getComponentConfig} from "../../utils/components";
import InvoiceEditor from "./invoiceEditor";
import ModalEditor from "./ModalEditor";
import PrintButton from "../form/PrintButton";

class InvoicingEditor extends React.Component {

    state = {
        message: null,
        messageType: null
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    getFieldProps = (field) => {
        const props = this.props.getFieldProps(field);
        if (this.props.values[this.props.componentConfig.idfield] && this.props.values.state + '' !== '0') {
            props.disabled = props.disabled || true;
        }
        return props;
    }


    componentDidMount() {
        this.componentConfigRequest = getComponentConfig('InvoicingItem');
        this.componentConfigRequest.then((componentConfig) => {
            const invoicing_types = componentConfig.objects.map(item => { return { component: item }; });
            this.setState({ invoicing_types: invoicing_types });
        });
    }

    createInvoice = async () => {
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.createInvoice',
                id: this.props.values[this.props.componentConfig.idfield]
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            return response;
        });
    }

    deleteForm = async () => {
        await this.props.deleteForm();
        this.editor && this.editor.hide();
    }

    render() {
        if (!((this.props.till || {}).pos || {}).id) {
            return <Box header="Hiba" theme="danger">
                Kérlek jelentkezz be egy eladási helyre!
            </Box>;
        }
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const Other = this.props.other || Fragment;
        return (
            <Fragment>
                <Modal
                    state={this.state.message !== null ? "on" : "off"}
                    theme={this.state.messageType}
                    size={"large"}
                    header={"Mentés"}
                    buttons={[
                        {
                            text: 'Ok',
                            onClose: true,
                            onClick: async () => {
                                this.setState({message: null, messageType: null});
                            }
                        }
                    ]}
                >
                    {this.state.message}
                </Modal>
                <List
                    {...this.props}
                    theme="default"
                    header="Kimenő számlák"
                    footer={[
                        <Button
                            key="0"
                            color="default"
                            disabled={this.props.isLoading}
                            onClick={this.pristineForm}>
                            Új
                        </Button>
                    ]}
                >
                    <InvoicingList
                        ref={(el) => this.list = el}
                        {...this.props}
                        loadForm={this.loadForm}
                        filter={[{field: "seller", value: this.props.pos.partner.partner_id}]}
                    />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Kimenő számla"
                    footer={<Fragment>
                        {this.props.values[this.props.componentConfig.idfield] && this.props.values.state + '' === '0' && <Button
                            disabled={this.props.isLoading || this.props.dirty}
                            color="primary"
                            className="pull-right"
                            onClick={this.createInvoice}
                        >
                            Számlázás
                        </Button>}
                        <Button
                            disabled={this.props.isLoading || !this.props.dirty}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>
                        {this.props.values[this.props.componentConfig.idfield] && this.props.values.state + '' === '30' && <PrintButton
                            {...this.props}
                            type="pdf"
                            className="pull-right"
                            icon={{lib: "fas", name: "download"}}
                            color="default"
                            disabled={this.props.isLoading || this.props.dirty}
                        >
                            Letöltés
                        </PrintButton>}
                        {this.props.values[this.props.componentConfig.idfield] && (this.props.values.state + '' === '30' || this.props.values.state + '' === '0') && <Button
                            color="danger"
                            className="pull-left"
                            onClick={this.deleteForm}
                        >
                            Törlés
                        </Button>}
                    </Fragment>}
                >
                    <InvoicingForm
                        ref={(form) => this.form = form}
                        {...this.props}
                        invoicing_types={this.state.invoicing_types}
                        getFieldProps={this.getFieldProps}
                    />
                </Editor>
                <Other>
                    {this.props.values[this.props.componentConfig.idfield] && <InvoiceEditor
                        editorContext="InvoicingInvoiceEditor"
                        gridid="InvoicingInvoiceList"
                        pageSize={0}
                        listFilter={[
                            {
                                field: "component",
                                value: this.props.componentConfig.componentname
                            },{
                                field: "component_id",
                                value: this.props.values[this.props.componentConfig.idfield]
                            }
                        ]}
                        editor={ModalEditor}
                        selection={null}
                        onProcessAction={() => {
                            if (!this.props.isLoading) {
                                this.props.reloadForm && this.props.reloadForm();
                            }
                        }}
                    />}
                </Other>
            </Fragment>
        );
    }
}

export default connect((state) => {
    return {
        pos: (state.app.till || {}).pos || {},
        till: state.app.till,
        user: state.app.user
    };
},{showModal})(createEditor({
    componentName: "Invoicing",
    editor: "Invoicing",
    WrappedComponent: InvoicingEditor,
    props: {
        componentActions: async (action, data, params) => {
            params.preset = "Invoicing";
            data = {...data};
            return {action,data,params};
        }
    }
}));
